<script lang="ts">
	import { siteConfig } from '$lib/config/site';
	import { mode } from '$lib/state/global.svelte';
	let { footer } = $props();

	const year = new Date().getFullYear();
</script>

<footer class="py-6 md:px-8 md:py-0">
	<div class="container flex flex-col items-center justify-between gap-4 md:h-16 md:flex-row">
		<div class="flex w-full flex-col items-center gap-4 px-8 md:flex-row md:gap-2 md:px-0">
			<div
				class="flex w-full flex-col text-center text-sm leading-loose text-muted-foreground md:flex-row md:justify-between md:gap-4 md:text-left"
			>
				<div class="flex flex-row items-center gap-2 max-md:flex-col">
					<a href="/" class="flex items-center space-x-2">
						{#if $mode === 'dark'}
							<img alt="MVMNT" src={siteConfig.darkLogo} class="w-[90px]" />
						{:else}
							<img alt="MVMNT" src={siteConfig.lightLogo} class="w-[90px]" />
						{/if}
					</a>
					<span class="md:whitespace-nowrap"
						>{siteConfig.legalName} © {year} All Rights Reserved.</span
					>
				</div>
				<div
					class="flex flex-col text-center text-sm leading-loose text-muted-foreground md:mr-6 md:flex-row md:gap-4 md:text-left"
				>
					{#each footer as nav}
						<a class="whitespace-nowrap" href={nav.path}>{nav.title}</a>
					{/each}
				</div>
			</div>
		</div>
	</div>
</footer>
